import { initIntakeFormThunk } from 'actions/intakeForm/IntakeFormActions';
import { IntakeFormDisabled } from 'components/IntakeForm/Disabled/IntakeFormDisabled';
import { IntakeForm } from 'components/IntakeForm/IntakeForm';
import { LoadingOverlay } from 'components/UI/LoadingOverlay/LoadingOverlay';
import { useIsIntakeFormEnabled } from 'hooks/useIsIntakeFormEnabled';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getIntakeFormLoading, getIntakeFormStep } from 'reducers/intakeForm/IntakeFormSelectors';
import { IntakeFormStep } from 'reducers/intakeForm/IntakeFormState';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';

export const IntakeFormPage: React.FC = () => {
    const dispatch = useDispatch();
    const isIntakeFormEnabled = useIsIntakeFormEnabled();
    const queryParams = useParams<{ slug: string }>();

    const step = useSelector(getIntakeFormStep);
    const isLoading = useSelector(getIntakeFormLoading);
    const marketplace = useSelector(getMarketplace);

    React.useEffect(() => {
        if (marketplace.id === 0 || marketplace.slug !== queryParams.slug) {
            dispatch(initIntakeFormThunk(queryParams.slug));
        }
        // eslint-disable-next-line
    }, []);

    if (isLoading && step === IntakeFormStep.Initial) {
        return <LoadingOverlay />;
    }

    if (!isIntakeFormEnabled) {
        return <IntakeFormDisabled />;
    }

    return <IntakeForm />;
};
